<style>
.pop-select-dropdown-list .pop-tree li {
  padding-left: 16px;
}
.pop-select-dropdown-list .pop-tree li span.pop-tree-switcher,
.pop-tree li span.pop-tree-iconEle {
  left: 0;
  top: 1px;
}
.pop-disabled-cursor {
  cursor: not-allowed !important;
}
</style>

<template>

  <div :class="classes" v-el:lookup v-clickoutside="handleClose">
    <div :class="[prefixCls + '-selection']" v-el:reference @click="toggleMenu">
      <div
        :class="[PRE+'-tag',disabled?PRE+'-disabled-cursor':'']"
        v-for="(index,item) in selectedMultiple"
        :key="item.id"
      >
        <span :class="[PRE+'-tag-text']">{{ item.name }}</span>
        <p-icon
          type="ios-close-empty"
          @click.stop="removeTag(index,item.id)"
          :class="[disabled?PRE+'-disabled-cursor':'']"
        ></p-icon>
      </div>
      <span :class="[prefixCls + '-placeholder']" v-show="showPlaceholder">{{ localePlaceholder }}</span>
      <p-icon
        type="ios-close"
        :class="[prefixCls + '-arrow']"
        v-show="showCloseIcon"
        @click.stop="clearSingleSelect"
      ></p-icon>
      <p-icon type="ios-arrow-down" :class="[prefixCls + '-arrow']" v-if="!remote"></p-icon>
    </div>
    <Drop v-show="dropVisible" :placement="placement" v-ref:dropdown :transition="transitionName">
      <ul v-show="baseData[0]?!baseData[0].show:false" :class="[prefixCls + '-not-found']">
        <li>{{ localeNotFoundText }}</li>
      </ul>
      <div
        v-show="(!notFound && !remote) || (remote && !loading && !notFound)"
        :class="[prefixCls + '-dropdown-list']"
        v-el:list
      >
        <tree
          :setting="setting"
          :nodes="nodes"
          @on-click="onClick"
          @on-check="onCheck"
          @on-created="handleCreated"
          @on-check-node="onCheckNode"
          @on-cancel-checked="onCancelChecked"
          @on-clear-all="clearSingleSelect"
          v-ref:ztree
        ></tree>
      </div>
      <!-- <ul v-show="loading" :class="[prefixCls + '-loading']">{{ localeLoadingText }}</ul> -->
    </Drop>
    <div
      :class="[formPrefixCls + '-error-msg-tip']"
      v-if="validateMessage && showMessage"
    >{{ validateMessage }}</div>
    <!-- {{baseData|json}} -->
  </div>
</template>
<script>
import { oneOf, PRE } from "../../common/utils/assist";
import Drop from "./dropdown.vue";
import directives from "../../common/directives/directives";
import { getJSON } from "../common/utils";
import tree from "./ztree.vue";
import Emitter from "../../common/mixins/emitter";
import AsyncValidator from "async-validator";
const prefixCls = `${PRE}-select`;
const formPrefixCls = `${PRE}-form-item`;

export default {
  name: "MultiCategory",
  mixins: [Emitter],
  components: { Drop, tree },
  directives: { clickoutside: directives.clickoutside },
  ready() {
    // 判断是否需要是编辑，model是否有值需要回显
    this.getData();
  },
  props: {
    model: {
      type: [Array, String],
      default() {
        return [];
      }
    },
    dataOrigin: {
      type: String,
      default: "7fresh"
    },
    type: {
      type: String,
      default: "category"
    },
    label: {
      type: [String, Number, Array],
      default: ""
    },
    multiple: {
      type: Boolean,
      default: true
    },
    debug: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    filterable: {
      type: Boolean,
      default: true
    },
    filterMethod: {
      type: Function
    },
    remote: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large", "default"]);
      }
    },
    labelInValue: {
      type: Boolean,
      default: false
    },
    notFoundText: {
      type: String
    },
    validateMessage: null,
    showMessage: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    placement: {
      validator(value) {
        return oneOf(value, ["top", "bottom"]);
      },
      default: "bottom"
    }
  },
  data() {
    return {
      nodes: [],
      ztreeObj: null,
      setting: {
        check: {
          enable: true
        },
        data: {
          simpleData: {
            enable: true,
            pIdKey: "pid"
          }
        },
        view: {
          showIcon: false,
          addHoverDom: this.addHoverDom,
          removeHoverDom: this.removeHoverDom
        }
      },
      getCategoryUrl:this.dataOrigin=='7fresh'?"https://category.7fresh.com/category/standardizedCategory/getAuthCategoryForUI":'https://product.7fresh.com/api/category/getMtFrontCategoryForUI',
      getDepartmentUrl:"https://org.7fresh.com/shop/api/list/1",
      baseData: [],
      PRE: PRE,
      prefixCls: prefixCls,
      formPrefixCls: formPrefixCls,
      visible: false,
      options: [],
      selectedSingle: "", // label
      focusIndex: 0,
      query: "",
      selectToChangeQuery: false, // when select an option, set this first and set query, because query is watching, it will emit event
      inputLength: 20,
      notFound: false,
      validateState: "",
      value: [],
      selectedMultiple: []
    };
  },
  computed: {
    getUrl(){
      switch(this.type){
        case 'category':
          return this.getCategoryUrl
        case 'department':
          return this.getDepartmentUrl
        default:
          return this.getCategoryUrl
      }
    },
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${PRE}-form-item-error`]: this.validateState == "error",
          [`${prefixCls}-visible`]: this.visible,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-multiple`]: this.multiple,
          [`${prefixCls}-single`]: !this.multiple,
          [`${prefixCls}-show-clear`]: this.showCloseIcon,
          [`${prefixCls}-${this.size}`]: !!this.size
        }
      ];
    },
    showPlaceholder() {
      if (this.model && this.model.length) {
        return false;
      }
      return true;
    },
    showCloseIcon() {
      return this.clearable && this.selectedMultiple.length;
    },
    inputStyle() {
      let style = {};
      if (this.multiple) {
        if (this.showPlaceholder) {
          style.width = "100%";
        } else {
          style.width = `${this.inputLength}px`;
        }
      }
      if (this.disabled) {
        style.display = "none";
      }
      return style;
    },
    localePlaceholder() {
      if (this.placeholder === undefined) {
        return "";
      } else {
        return this.placeholder;
      }
    },
    localeNotFoundText() {
      if (this.notFoundText === undefined) {
        return "无匹配数据";
      } else {
        return this.notFoundText;
      }
    },
    transitionName() {
      return this.placement === "bottom" ? "slide-up" : "slide-down";
    },
    dropVisible() {
      let status = true;
      const options = [];
      if (!this.loading && this.remote && this.query === "" && !options.length)
        status = false;
      return this.visible && status;
    }
  },
  methods: {
    getData() {
      let d = getJSON(
        this.getUrl,
        "GET"
      );
      d.done(data => {
        this.nodes = data;
        this.onChange();
        this.$nextTick(function() {
          this.$emit("on-data-loaded", this);
        });
      });
    },
    // model 变化了
    onChange(ids) {
      if (
        this.model &&
        this.model.length &&
        this.nodes.length &&
        this.ztreeObj
      ) {
        this.model.map(item => {
          this.$refs.ztree.updateNode(item);
        });
      }
      // 设置tag
      this.setSelectedTags();
      if (ids) {
        this.validateFn();
        this.$emit("on-change", ids);
      }
    },
    getStoreById(id) {
      return this.nodes.find(store => store.id == id);
    },
    setSelectedTags() {
      this.selectedMultiple = [];
      let w = 0;
      if (!this.model || this.model.length == 0) return;
      for (let sid of this.model) {
        let { id = "", name = "" } = this.getStoreById(sid) || {};
        if (id && name) {
          this.selectedMultiple.push({
            id,
            name
          });
        }
      }
      this.$nextTick(() => {
        const nodeList = this.$els.lookup.querySelectorAll(".pop-tag");
        const arrayList = Array.from(nodeList);
        w = arrayList.length
          ? arrayList.reduce((a, b) => {
              return (a.offsetWidth ? a.offsetWidth : a) + b.offsetWidth;
            })
          : 0;
        if (w > this.$els.lookup.offsetWidth - arrayList.length * 4 - 40) {
          this.selectedMultiple = [
            {
              id: -1,
              name: `已选择${this.selectedMultiple.length}个类目`
            }
          ];
        }
      });
    },
    removeTag(index, id) {
      if (this.disabled) {
        return false;
      }
      if (id == -1) {
        // 全部删除
        this.clearSingleSelect();
      } else {
        this.selectedMultiple.splice(index, 1);
        this.model.splice(this.model.findIndex(sid => sid == id), 1);
        // 单项删除
        this.$refs.ztree.removeNode(id);
        //this.onChange(this.model);
      }
      // this.broadcast('Drop', 'on-update-popper');
    },
    clearSingleSelect() {
      if (this.disabled) return;
      // 全部清除
      this.selectedMultiple = [];
      this.model = [];
      this.$refs.ztree.cancelAllNodes();
    },
    onClick(evt, treeId, treeNode) {
      console.log(evt.type, treeNode);
    },
    // 回显node选中回调
    onCheckNode(ids) {
      // 去重
      let tempArr = this.model.concat(ids);
      this.model = tempArr.filter((item, index) => {
        return tempArr.indexOf(item) === index;
      });
    },
    onCancelChecked(ids) {
      // 去重 [1,2,3]  [3,4,5,6]   => [1,2]
      let tempArr = this.model.concat(ids); // 合在一起，找出出现两次的组成removeArr
      let removeArr = tempArr.filter((item, index) => {
        return tempArr.indexOf(item) !== index;
      });
      for (var i in removeArr) {
        for (var k in this.model) {
          if (removeArr[i] == this.model[k]) {
            this.model.splice(k, 1);
          }
        }
      }
    },
    onCheck(evt, treeId, treeNode) {
      console.log(treeId, treeNode)
      // 选中事件
      // 绑定的model值更改，并且告知用户当前选择或取消的是哪个节点
      this.model = this.model ? this.model : [];
      // 判断是选中还是取消
      if (treeNode.checked) {
        this.$refs.ztree.selectOneCheck(treeNode);
      } else {
        // 取消check
        this.$refs.ztree.cancelChecked(treeNode);
      }
    },
    handleCreated(ztreeObj) {
      this.ztreeObj = ztreeObj;
      if (ztreeObj) {
        this.onChange();
      }
      // onCreated 中操作ztreeObj对象展开第一个节点
      // ztreeObj.expandNode(ztreeObj.getNodes()[0], true);
    },
    toggleMenu() {
      if (this.disabled) {
        return false;
      }
      this.visible = !this.visible;
    },
    hideMenu() {
      this.visible = false;
      this.focusIndex = 0;
    },
    // find option component
    handleClose() {
      this.hideMenu();
    },
    handleKeydown(e) {
      if (this.visible) {
        const keyCode = e.keyCode;
        // Esc slide-up
        if (keyCode === 27) {
          e.preventDefault();
          this.hideMenu();
        }
      }
    },
    handleBlur() {
      setTimeout(() => {
        const model = this.value;
        if (this.multiple) {
          this.query = "";
        }
      }, 300);
    },
    resetInputState() {
      this.inputLength = this.$els.input.value.length * 12 + 20;
    },
    validateFn(callback) {
      if (this.rules.length) {
        var validator = new AsyncValidator({
          Store: this.rules
        });
        var tmp = this.model;
        validator.validate({ Store: tmp }, { firstFields: true }, errors => {
          this.validateMessage = errors ? errors[0].message : "";
          this.validateState = !errors ? "success" : "error";
          callback ? callback(this.validateMessage) : null;
        });
      } else {
        this.validateMessage = "";
        this.validateState = "";
      }
    }
  },
  compiled() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  watch: {
    model(val) {
      this.onChange(val);
    },
    query(val) {
      if (!this.selectToChangeQuery) {
        this.$emit("on-query-change", val);
      }
      this.selectToChangeQuery = false;
      this.broadcast("Drop", "on-update-popper");
    }
  },
  events: {
    "on-form-reset"(field) {
      if (field) {
        this.validateMessage = "";
        this.validateState = "";
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// multi-category.vue?49bb37e4